import ItemQuizBase from 'es6/controllers/apps/quizzes/item-quiz-base';
import Study from 'es6/controllers/apps/quizzes/study';
import RapidChoicePair from 'es6/controllers/apps/quizzes/rapid-choice-pair';
import ReverseRapidChoicePair from 'es6/controllers/apps/quizzes/reverse-rapid-choice-pair';
import SentenceStudyListeningFillInTheBlankPartial from 'es6/controllers/apps/quizzes/sentence-study-listening-fill-in-the-blank-partial';
import SentenceStudyListeningFillInTheBlank from 'es6/controllers/apps/quizzes/sentence-study-listening-fill-in-the-blank';
import SentenceStudyListeningAssembly from 'es6/controllers/apps/quizzes/sentence-study-listening-assembly';
import SentenceStudyTranslationAssembly from 'es6/controllers/apps/quizzes/sentence-study-translation-assembly';
import SelfAssessment, { SelfAssessmentBinary } from 'es6/controllers/apps/quizzes/self-assessment';
import ReverseSelfAssessment, { ReverseSelfAssessmentBinary } from 'es6/controllers/apps/quizzes/reverse-self-assessment';

export class MultipleChoiceLimited extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('MultipleChoiceLimited');
    this.recall = 'cue';
    this.quizContent = 'response';
    this.screen = 'multiple_choice_five';
  }
}

export class ReverseMultipleChoiceLimited extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('ReverseMultipleChoiceLimited');
    this.recall = 'response';
    this.quizContent = 'cue';
    this.screen = 'multiple_choice_five';
    this.showHint = true;
  }
}

export class SentenceMultipleChoiceLimited extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('SentenceMultipleChoiceLimited');
    this.recall = 'blank_sentence_and_translation';
    this.quizContent = 'cue';
    this.screen = 'multiple_choice_five';
    this.requiresSentence = true;
    this.requiresSentenceTranslation = true;
  }
}

export class TransliterationMultipleChoiceLimited extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('TransliterationMultipleChoiceLimited');
    this.recall = 'cue_with_no_reading';
    this.quizContent = 'transliteration';
    this.screen = 'multiple_choice_five';
  }
}

export class ReverseTransliterationMultipleChoiceLimited extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('ReverseTransliterationMultipleChoiceLimited');
    this.recall = 'transliteration';
    this.quizContent = 'cue';
    this.screen = 'multiple_choice_five';
  }
}

export class ListeningMultipleChoiceLimited extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('ListeningMultipleChoiceLimited');
    this.recall = 'sound';
    this.quizContent = 'response';
    this.screen = 'multiple_choice_five';
  }
}

export class ReverseFillInTheBlank extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('ReverseFillInTheBlank');
    this.recall = 'response';
    this.quizContent = 'cue';
    this.screen = 'fill_in_the_blank';
    this.showHint = true;
  }
}

export class TransliterationFillInTheBlank extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('TransliterationFillInTheBlank');
    this.recall = 'cue_with_no_reading';
    this.quizContent = 'transliteration';
    this.screen = 'fill_in_the_blank';
  }
}

export class SentenceFillInTheBlank extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('SentenceFillInTheBlank');
    this.recall = 'blank_sentence_and_translation';
    this.quizContent = 'recall';
    this.screen = 'fill_in_the_blank';
    this.requiresSentence = true;
    this.requiresSentenceTranslation = true;
  }
}

export class DictationFillInTheBlank extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('DictationFillInTheBlank');
    this.recall = 'blank_sentence';
    this.quizContent = 'recall';
    this.screen = 'fill_in_the_blank';
    this.requiresSentence = true;
    this.requiresSentenceAudio = true;
  }
}

export default Object.freeze({
  DictationFillInTheBlank,
  ListeningMultipleChoiceLimited,
  MultipleChoiceLimited,
  RapidChoicePair,
  ReverseFillInTheBlank,
  ReverseMultipleChoiceLimited,
  ReverseRapidChoicePair,
  ReverseSelfAssessment,
  ReverseSelfAssessmentBinary,
  ReverseTransliterationMultipleChoiceLimited,
  SelfAssessment,
  SelfAssessmentBinary,
  SentenceFillInTheBlank,
  SentenceMultipleChoiceLimited,
  SentenceStudyListeningFillInTheBlankPartial,
  SentenceStudyListeningFillInTheBlank,
  SentenceStudyListeningAssembly,
  SentenceStudyTranslationAssembly,
  Study,
  TransliterationFillInTheBlank,
  TransliterationMultipleChoiceLimited,
});
